import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Print from 'vue-print-nb'
import JsonCSV from "vue-json-csv";
import VueHtmlToPaper from 'vue-html-to-paper';

// const options = {
//   name: '_blank',
//   specs: [
//     'fullscreen=yes',
//     'titlebar=yes',
//     'scrollbars=yes'
//   ],
//   styles: [
//     'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css',
//     'https://unpkg.com/kidlat-css/css/kidlat.css'
//   ]
// }

// Vue.use(VueHtmlToPaper, options);


Vue.component("downloadCsv", JsonCSV);


Vue.use(Print)
Vue.use(axios, VueAxios)



const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://cdn.jsdelivr.net/npm/vuetify/dist/vuetify.js',
    'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css'
  ],

  // autoClose: true, // if false, the window will not close after printing
  // windowTitle: window.document.title, // override the window title
}

Vue.use(VueHtmlToPaper, options);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
